function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.278 8l-.707.707-7.071 7.071-.707-.707L19.364 8.5H0v-1h19.364L12.793.929 13.5.222 21.278 8z",
  fill: "#D9D9D9"
});

function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 16",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDIyIDE2IiBmaWxsPSJub25lIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS4yNzgyIDcuOTk5ODZMMjEuMjc4MiA3Ljk5OTkzTDIwLjU3MTEgOC43MDY5NkwxMy41IDE1Ljc3ODFMMTIuNzkyOSAxNS4wNzFMMTkuMzY0IDguNDk5ODZIMFY3LjQ5OTg2SDE5LjM2NEwxMi43OTI5IDAuOTI4Nzg2TDEzLjUgMC4yMjE2OEwyMS4yNzgyIDcuOTk5ODZaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=";
export { SvgRight as ReactComponent };